import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {AlertTicket, colorByAlertStatus, TicketFaultStatus} from "@shared/services";
import {Moment} from 'moment-timezone';


interface DisplayData {
  faultStatus: TicketFaultStatus;
  lastFaultTransitionedAt?: Moment;
}


@Component({
  selector: 'app-escalated-ticket-alert-status',
  templateUrl: './escalated-ticket-alert-status.component.html',
  styleUrl: './escalated-ticket-alert-status.component.scss',
  standalone: false
})
export class EscalatedTicketAlertStatusComponent implements OnChanges {
  @Input() alertTickets: AlertTicket[];

  readonly TicketFaultStatus = TicketFaultStatus;
  readonly colorByAlertStatus = colorByAlertStatus;
  displayData: DisplayData | null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.alertTickets) {
      this.displayData = this.getDisplayData(this.alertTickets);
    }
  }

  private getDisplayData(alertTickets: AlertTicket[]): DisplayData | null {
    if (alertTickets?.length) {
      let recoveredAlert: AlertTicket;
      let oldestFault: AlertTicket;
      alertTickets.forEach(alert => {
        const faultStatus = alert.fault_status;
        if (faultStatus === TicketFaultStatus.FAULT) {
          if (!oldestFault || oldestFault.last_fault_transitioned_at.isAfter(alert.last_fault_transitioned_at)) {
            oldestFault = alert;
          }
        } else if (faultStatus === TicketFaultStatus.RECOVERED) {
          recoveredAlert = alert;
        } else {
          throw new Error('Unrecognized fault status: ' + faultStatus);
        }
      });
      return oldestFault
        ? {faultStatus: TicketFaultStatus.FAULT, lastFaultTransitionedAt: oldestFault.last_fault_transitioned_at}
        : (recoveredAlert ? {faultStatus: TicketFaultStatus.RECOVERED} : null);
    }
    return null;
  }
}
